import { render, staticRenderFns } from "./ztpxDetail.vue?vue&type=template&id=4a4d4a6e"
import script from "./ztpxDetail.vue?vue&type=script&lang=js"
export * from "./ztpxDetail.vue?vue&type=script&lang=js"
import style0 from "./ztpxDetail.vue?vue&type=style&index=0&id=4a4d4a6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports